export const TableAlertBanner = ({
  isError,
  message = '',
}: {
  isError: boolean;
  message?: string;
}) => {
  return isError
    ? {
        color: 'red',
        children:
          message !== '' ? message : 'An error occurred while fetching data',
        'data-testid': 'table-alert-banner',
      }
    : undefined;
};
